module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('color-picker', {
    attrs: {
      "label": _vm.$t('edit.sidebar.text_color'),
      "id": "triggerButtonTextColor",
      "value": _vm.boxConfig.trigger_button.style.color,
      "change": _vm.onColorChange,
      "move": _vm.onMove
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-959abb40!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/triggerbutton/TextColor.vue
 ** module id = 886
 ** module chunks = 1
 **/